import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Form, Input, notification, Row, Col, Button, Modal, Breadcrumb, Typography, Spin, Select } from 'antd';
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 24 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 24 },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 24,
      offset: 0,
    },
  },
};
const State = props => {
  const { section, id } = useParams();
  const [location, setLocation] = useState({});
  const [loading, setLoading] = useState(false);
  const formRef = useRef(null);
  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        if (id !== 'new') {
          let { data } = await props.getItem('states', id);
          setLocation(data);
          formRef.current.setFieldsValue(data);
        }
      } catch (error) {
        Modal.warning({
          title: 'Error',
          content: 'Unexpected error occured',
        });
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [section, id]);

  let onFinish = values => {
    setLoading(true);
    let newState = { ...location, ...values };
    props
      .saveItem('states', newState)
      .then(
        response => {
          setLoading(false);
          if (response) {
            notification['success']({
              message: 'States saved successfully!',
              duration: 2,
            });
            setTimeout(() => props.history.push('/settings/states', 1500));
          }
        },
        errorReponse => {
          if (errorReponse.errors !== undefined) {
            for (var i = 0; i < errorReponse.errors.length; i++) {
              var errorObj = errorReponse.errors[i];
              var errorField = errorObj.extensions.field;
              var errorFieldMessage = errorObj.message;
              formRef.current.setFields([
                {
                  name: errorField,
                  errors: [errorFieldMessage],
                },
              ]);
            }
          } else {
            Modal.warning({
              title: 'Error',
              content: 'Unexpected error occured',
            });
          }
        }
      )
      .catch(error => {
        setLoading(false);
        Modal.warning({
          title: 'Error',
          content: 'Not Saved!',
        });
      });
    setLoading(false);
  };
  let onFinishFailed = ({ errorFields }) => {
    formRef.current.scrollToField(errorFields[0].name);
  };
  let backButton = () => {
    setTimeout(() => props.history.push('/settings/states', 1500));
  };
  return (
    <>
      <Spin spinning={loading} size="large">
        <Row>
          <Col className="app-breadcrumb-col">
            <Breadcrumb separator="/" items={[{ title: "Settings", href: "/settings/states" }, { title: "States", href: "/settings/states" }, { title: id != 'new' ? `Edit State` : 'Add State' }]} />
          </Col>
          <Col className="white-paper">
            <Row gutter={24} className="page-header-section" align="middle">
              <Col xs={12}>
                <Typography.Title level={4} style={{ margin: 0 }}>
                  {id != 'new' ? `Edit State: ${id}` : 'Add State'}
                </Typography.Title>
              </Col>
              <Col xs={12} justify="end"></Col>
            </Row>
            <hr />
            <div className="artist">
              <Form
                ref={formRef}
                layout="vertical"
                {...formItemLayout}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                initialValues={{ layout: tailFormItemLayout }}
              >
                <Row gutter={24}>
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <Form.Item
                      name="state"
                      label="State"
                      rules={[
                        {
                          required: true,
                          message: 'State is required!',
                        },
                      ]}
                    >
                      <Input placeholder="Enter State" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <Form.Item
                      name="code"
                      label="Alpha code"
                      rules={[
                        {
                          whitespace: true,
                          required: true,
                          message: 'Alpha code is required!',
                        },
                      ]}
                    >
                      <Input placeholder="Enter alpha code" />
                    </Form.Item>
                  </Col>
                </Row>
                <Form.Item {...tailFormItemLayout}>
                  <Button
                    type="default"
                    htmlType="button"
                    onClick={backButton}
                    style={{
                      borderColor: '#d9d9d9',
                      background: '#f5f5f5',
                      color: 'rgba(0, 0, 0, 0.85)',
                    }}
                  >
                    Back
                  </Button>
                  {props.showButton(props.roleType, props.tabs_permissions.settings_states, !!location ? location.id : '')}
                </Form.Item>
              </Form>
            </div>
          </Col>
        </Row>
      </Spin>
    </>
  );
};

export default State;
